import React, { useEffect, useState } from "react";
import './OpalDashboardLayout.css';
import OpalHostContainer from "./OpalHostContainer/OpalHostContainer";
import { OpalDashboardFactoryComponent } from "./OpalDashboardFactoryComponent/OpalDashboardFactoryComponent";

const OpalDashboardLayout = () => {

    const [itemSection, setItemSections] = useState([]);
    const [chartPalettes, setChartPalettes] = useState([]);
    const [chartThemes, setChartThemes] = useState([]);

    useEffect(() => {
        const storedPermission = localStorage.getItem("permission");
        const permission = JSON.parse(atob(storedPermission));

        const data = OpalDashboardFactoryComponent(permission?.coverage?.dashboard);
        setItemSections(data.sections);
        setChartPalettes(data.colorScheme.palettes);
        setChartThemes(data.colorScheme.themes);
    }, [])

    return (
        <div className="row">
            <main className="flex-grow-1 col-md-9 col-lg-9 p-0 m-0">
                <div className='host-container' tag="main">
                    <div className="opal-dashboard-layout-container d-flex h-100">
                        <OpalHostContainer
                            itemSection={itemSection}
                            chartPalette={chartPalettes}
                            chartTheme={chartThemes}
                            autoScale={true}
                        />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default OpalDashboardLayout;
